export enum DisableRuleSupplierActionEnum {
  none = 'none',
  remove = 'remove',
  set = 'set',
}
